import request from './request'

export function init(entry) {
  const url = '/course_detail/vipdetail'
  return request.get(url, {
    params: {
      entry
    }
  })
}


// WEBPACK FOOTER //
// ./src/api/vip.js